global.antRouter = '' // 全局的路由



// WEBPACK FOOTER //
// ./src/utils/global.js